<template>
  <CCard v-if="!markLoading">
    <CCardHeader class="d-flex justify-content-between align-items-center">
      دانش آموزان
    </CCardHeader>
    <CCardBody class="d-flex align-items-center text-center h-100">
      <CDataTable
          class="w-100 d-flex justify-content-between h-100"
          :noItemsView="{
          noItems: 'در حال حاضر محتوایی در این قسمت وجود ندارد',
        }"
          :items="computedMarkList"
          :fields="fields"
          hover
          striped
          border
          small
          fixed
          :loading="loading"
      >
        <template #showAnswer="{ item }">
          <td>
            <router-link
                :to="`/${$type.toLowerCase()}/exam/${$route.params.id}/${
                item.id
              }`"
            >
              <CButton
                  class="modal-button"
                  square
                  size="sm"
                  @click="selectedItem = item"
              >
                مشاهده
              </CButton>
            </router-link>
            <router-view @go-to="goTo"></router-view>
          </td>
        </template>
      </CDataTable>
    </CCardBody>
    <CCardFooter>
      <CButton color="primary" square size="sm" class="px-5 py-2" @click="onDownloadExcel">دریافت اکسل</CButton>
    </CCardFooter>
  </CCard>
</template>

<script>
import axios from "@/plugins/axios";

export default {
  name: "StudentTable",
  data() {
    return {
      loading: false,
      markLoading: false,
      students: [],
      markMap: null,
      fields: [
        {key: "studentName", label: "نام"},
        {key: "studentLastname", label: "نام خانوادگی"},
        {key: "showAnswer", label: "نمایش پاسخ"},
        {key: "examMark", label: "نمره"},
        {key: "examPercent", label: "درصد"},
        {key: "examRank", label: "رتبه"},
      ],
      selectedItem: {},
    };
  },
  computed: {
    computedMarkList() {
      return this.students.map((item) => {
        return {
          ...item,
          studentName: item.name,
          studentLastname: item.lastname,
          examMark: this.markMap.has(item.id)
              ? this.markMap.get(item.id).markString
              : "",
          examPercent: this.markMap.has(item.id)
              ? this.markMap.get(item.id).percent
              : "",
          examRank: this.markMap.has(item.id)
              ? this.markMap.get(item.id).rank
              : "",
        };
      });
    },
  },
  mounted() {
    this.getStudentMarks();
    this.getStudents();
  },
  methods: {
    async getStudentMarks() {
      try {
        this.markLoading = true;
        this.markMap = new Map();
        const {id: examId} = this.$route.params;
        const {data} = await axios.get("/mark", {
          params: {examId: examId},
        });
        for (const i in data) {
          this.markMap.set(data[i].student.id, data[i]);
        }
      } catch (error) {
        console.log("errrror:", error);
      } finally {
        this.markLoading = false;
      }
    },
    async getStudents() {
      try {
        this.loading = true;
        const {id: examId} = this.$route.params;
        const {data} = await axios.get(`/exam/${examId}/answer/student`);
        this.students = data;
      } catch (error) {
        console.log("errrror:", error);
      } finally {
        this.loading = false;
      }
    },
    async onDownloadExcel() {
      try {
        this.loading = true;
        const {id: examId} = this.$route.params;
        const payload = [{
          key: 'examId',
          value: examId
        }]
        await axios
            .post('/report/7', payload)
            .then((response) => {
              window.open(response.data.url);
            });
      } catch (error) {
        console.log("error", error);
      } finally {
        this.loading = false;
      }
    },
    goTo(item, routeName) {
      this.$emit("go-to", routeName);
    },
  },
};
</script>

<style lang="scss" scoped></style>